var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"tournament-card"},[_c('h3',{staticClass:"tournament-card__title"},[_vm._t("title")],2),_c('div',{staticClass:"tournament-card__config"},[_vm._t("data")],2),_vm._t("registration")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }